// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Wzxl","notes":"Notes_notes__2NwPt"};